var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.375 0.375 23.25 23.25",
    strokeWidth: 0.75,
    height: 500,
    width: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shipment-packages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H2.625A1.914 1.914 0 0 0 .75 13.95v5.85a1.914 1.914 0 0 0 1.875 1.95h7.5A1.913 1.913 0 0 0 12 19.8V12",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12h3.75v5.25H4.5Z",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12V4.2a1.913 1.913 0 0 0-1.875-1.95h-7.5A1.914 1.914 0 0 0 6 4.2V12",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.25h3.75V7.5H9.75Z",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12v7.8a1.914 1.914 0 0 0 1.875 1.95h7.5a1.913 1.913 0 0 0 1.875-1.95v-5.85A1.913 1.913 0 0 0 21.375 12H12",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12h3.75v5.25h-3.75Z",
    fill: "none",
    stroke: "#ef5350",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.3b6378da292a33bf5348265684c5929a.svg";
export { ForwardRef as ReactComponent };